import React, { forwardRef } from 'react'

import cn from 'classnames'

import styles from './NavigationLarge.module.scss'
import { NavigationProps } from '../types'

const NavigationLarge: React.FC<NavigationProps> = forwardRef(
  ({ children, className, hasDataTrackingPii, testId, ...props }, ref) => (
    <a
      className={cn(styles.navigationLarge, className)}
      data-tracking-pii={hasDataTrackingPii}
      data-testid={testId}
      ref={ref}
      {...props}
    >
      {children}
    </a>
  ),
)

export default NavigationLarge
